"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var allScripts = {};
var defaultScript = function (source) { return ({ source: source, hasLoaded: false, isLoading: false, callbacks: {}, lastOrdinal: 0 }); };
var generateID = function () {
    var randomNumber = Math.random();
    return ("id-" + randomNumber).replace('.', '');
};
var createScriptElem = function (src, onLoad) {
    var $scriptElem = document.createElement('script');
    $scriptElem.setAttribute('class', 'load-js-script');
    document.head.appendChild($scriptElem);
    $scriptElem.onload = onLoad;
    $scriptElem.src = src;
};
function loadJS(src, callback) {
    var script = allScripts[src] || defaultScript(src);
    var callbacks = script.callbacks, hasLoaded = script.hasLoaded, isLoading = script.isLoading, lastOrdinal = script.lastOrdinal;
    var allCallBackIds = Object.keys(callbacks);
    var callbackID = allCallBackIds.filter(function (cbId) { return callbacks[cbId].cb === callback; })[0];
    if (hasLoaded && !isLoading) {
        if (callbackID) {
            var _a = callbacks[callbackID], cb = _a.cb, hasBeenCalled = _a.hasBeenCalled;
            if (!hasBeenCalled) {
                cb();
                callbacks[callbackID].hasBeenCalled = true;
            }
        }
        else {
            var newCallbackID = generateID();
            var newOrdinal = lastOrdinal + 1;
            callback();
            callbacks[newCallbackID] = {
                cb: callback,
                hasBeenCalled: true,
                id: newCallbackID,
                ordinal: newOrdinal,
            };
            script.lastOrdinal = newOrdinal;
        }
    }
    if (!hasLoaded && isLoading) {
        if (!callbackID) {
            var cbId = generateID();
            var newOrdinal = lastOrdinal + 1;
            callbacks[cbId] = {
                cb: callback,
                hasBeenCalled: false,
                id: cbId,
                ordinal: newOrdinal,
            };
            script.lastOrdinal = newOrdinal;
            allScripts[src] = script;
        }
    }
    if (!hasLoaded && !isLoading) {
        script.isLoading = true;
        createScriptElem(src, function () {
            script.isLoading = false;
            script.hasLoaded = true;
            script.source = src;
            if (!callbackID) {
                var cbId = generateID();
                callbacks[cbId] = {
                    cb: callback,
                    hasBeenCalled: true,
                    id: cbId,
                    ordinal: 0,
                };
                allScripts[src] = script;
            }
            var allCbIds = Object.keys(callbacks).sort(function (a, b) {
                if (callbacks[a].ordinal < callbacks[b].ordinal) {
                    return -1;
                }
                if (callbacks[a].ordinal > callbacks[b].ordinal) {
                    return 1;
                }
                return 0;
            });
            allCbIds.forEach(function (cbId) {
                callbacks[cbId].cb();
            });
        });
    }
    allScripts[src] = script;
}
exports.default = loadJS;
